var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedleInTheHaystackConsumerLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 474.14,
    height: 474.14,
    viewBox: "0 0 474.14 474.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8816",
    "data-name": "Group 8816",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M3,239.07C3,44.666,44.666,3,239.07,3S475.14,44.666,475.14,239.07,433.474,475.14,239.07,475.14,3,433.474,3,239.07Z",
    transform: "translate(-3 -3)",
    fill: "#ffffff",
    stroke: "#323232",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9851",
    "data-name": "Path 9851",
    d: "M32.855,392.636a.877.877,0,0,1-.878.773.89.89,0,0,1-.878-.773C25.968,350.47,0,131.787,0,32.468,0,14.547,14.319,0,31.959,0S63.917,14.547,63.917,32.468c0,99.319-25.967,317.984-31.1,360.168ZM23.209,34.627V50.3a8.786,8.786,0,1,0,17.569,0V34.627a8.786,8.786,0,1,0-17.569,0Z",
    transform: "translate(74.381 119.578) rotate(-45)",
    fill: "#002147",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedleInTheHaystackConsumerLogoMark);
export default __webpack_public_path__ + "static/media/needle_in_the_haystack_consumer_logo_mark.55afab58e8537c2fed2fa8415c788d1d.svg";
export { ForwardRef as ReactComponent };